/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */

import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Form,
  FormField,
  FormItem,
  FormControl,
  Input,
} from "@repo/ui";
import { useNavigate } from "react-router-dom";
import { ExcelRenderer } from "react-excel-renderer";
import { useEffect, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import sweetAlert from "components/sweet-alert";
import { Label } from "ui/label";
import { useCloseBulkTicket } from "services/tickets";
import Loader from "ui/page-loader";

export default function CloseBulkTickets() {
  const [closingTickets, setClosingTickets] = useState([]);
  const navigate = useNavigate();
  const closingForm = useForm({ defaultValues: { file: null } });

  const {
    mutate: closeTicket,
    data: closeTicketRes,
    isPending: closingTicket,
  } = useCloseBulkTicket();

  useEffect(() => {
    if (closeTicketRes) {
      navigate(-1);
    }
  }, [closeTicketRes]);

  const validateClosingTickets = (tickets) => {
    return tickets.every((item) => item.CaseNo);
  };

  const prepareClosingPayload = (tickets) => {
    return tickets.map((item) => ({
      caseNo: item.CaseNo || "",
      closingRemarks: item.ResolutionNotes || "",
    }));
  };

  const handleClosingConfirmation = (payload) => {
    sweetAlert({
      title: "Operation Confirmation",
      text: "Are you sure you want to close tickets",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      onConfirm: () => closeTicket(payload),
    });
  };

  const onSaveClosingBulk = () => {
    if (!validateClosingTickets(closingTickets)) {
      sweetAlert({
        title: "Invalid Data",
        text: "Required Fields Are Missing In List",
        icon: "error",
      });
      return;
    }

    const payload = prepareClosingPayload(closingTickets);
    handleClosingConfirmation(payload);
  };

  const processExcelData = (rows) => {
    const tickets = [];
    const keys = rows.shift(); // keys, header

    for (const row of rows) {
      if (row?.length) {
        const ticket = keys.reduce((acc, key, index) => {
          acc[key] = row[index] || "";
          return acc;
        }, {});

        tickets.push(ticket);
      }
    }

    return tickets;
  };

  const closingFileHandler = (event, field) => {
    const files = event?.target?.files;
    if (!files) {
      sweetAlert({
        title: "File Upload Failed",
        text: "Cannot Upload File",
        icon: "error",
      });
      return;
    }

    const fileObj = files[0];
    ExcelRenderer(fileObj, (err, resp) => {
      if (err) {
        sweetAlert({ title: "Operation Failure", text: err, icon: "error" });
        return;
      }

      const tickets = processExcelData(resp.rows);
      setClosingTickets(tickets);
      field.onChange(tickets);
    });
  };

  return (
    <>
      {closingTicket ? <Loader /> : null}

      <Card className="mt-4 flex flex-col flex-1 overflow-hidden">
        <CardHeader>
          <CardTitle>
            <div className="flex flex-row justify-between w-full gap-2">
              Close Tickets
              <Button
                variant="secondary"
                onClick={closingForm.handleSubmit(onSaveClosingBulk)}
              >
                Save
              </Button>
            </div>
          </CardTitle>
        </CardHeader>
        <Form {...closingForm}>
          <form className="space-y-8 custom-form-v2">
            <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
              <div className="form-row-d-50 flex flex-col flex-1 [&>.space-y-2]:!w-full">
                <FormField
                  control={closingForm.control}
                  name="file"
                  rules={{ required: "Please Upload File" }}
                  render={({ field }) => (
                    <FormItem>
                      <Label label="Upload File" isRequired />
                      <FormControl>
                        <div>
                          <Input
                            style={
                              closingForm.formState?.errors?.file
                                ? { borderColor: "red" }
                                : {}
                            }
                            type="file"
                            onChange={(event) => {
                              closingFileHandler(event, field);
                            }}
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          />
                          {closingForm.formState?.errors?.file ? (
                            <p className="text-destructive text-xs">
                              Please Upload File
                            </p>
                          ) : null}
                        </div>
                      </FormControl>
                    </FormItem>
                  )}
                />
              </div>

              {closingTickets.length > 0 && (
                <Grid data={closingTickets} className="list-tables-v1">
                  <GridColumn title="Ticket Number" field="CaseNo" />
                  <GridColumn
                    title="Resolution Notes"
                    field="ResolutionNotes"
                  />
                </Grid>
              )}
            </CardContent>
          </form>
        </Form>
      </Card>
    </>
  );
}
